/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Premium_Billed_Yearly_JustInputs */

const en_premium_billed_yearly_just = /** @type {(inputs: Premium_Billed_Yearly_JustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Billed at ${i?.price}/year, that's just:`)
};

const es_premium_billed_yearly_just = /** @type {(inputs: Premium_Billed_Yearly_JustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Facturado a ${i?.price}/año, son solo:`)
};

/**
* | output |
* | --- |
* | "Billed at {price}/year, that's just:" |
*
* @param {Premium_Billed_Yearly_JustInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_billed_yearly_just = /** @type {((inputs: Premium_Billed_Yearly_JustInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Billed_Yearly_JustInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_billed_yearly_just(inputs)
	return en_premium_billed_yearly_just(inputs)
});